module.exports = __webpack_public_path__ + "static/careDemo1-48a3826ff37dc816296af7bbbfbcc4ef.svg";